import React from "react";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import {
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBBadge,
  MDBIcon,
  MDBBtn,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBContainer,
  MDBInput,
} from "mdb-react-ui-kit";
import { PopConfirm } from "Projects/CC_cubi_clan_project/GlobalComponents/PopConfirm/PopConfirm";
import { TransactionModal } from "../TransactionModal/TransactionModal";
import { SharedExpenseSummary } from "../SharedExpenseSummary/SharedExpenseSummary";
import { ImportTransactionsModal } from "../ImportTransactionsModal/ImportTransactionsModal";
import { GrupoEditModal } from "../GrupoEditModal/GrupoEditModal";
import { AccountEditModal } from "../AccountEditModal/AccountEditModal";
import { ConfirmarPresupuestoModal } from "../ConfirmarPresupuestoModal/ConfirmarPresupuestoModal";
import "./DetalleCuenta.css";

export class DetalleCuenta extends React.Component {
  months = [
    { value: "00", label: "Todos los meses" },
    { value: "01", label: "Enero" },
    { value: "02", label: "Febrero" },
    { value: "03", label: "Marzo" },
    { value: "04", label: "Abril" },
    { value: "05", label: "Mayo" },
    { value: "06", label: "Junio" },
    { value: "07", label: "Julio" },
    { value: "08", label: "Agosto" },
    { value: "09", label: "Septiembre" },
    { value: "10", label: "Octubre" },
    { value: "11", label: "Noviembre" },
    { value: "12", label: "Diciembre" },
  ];

  mapaCategorias = [];
  saveTimers = {};
  userData = {};
  PAGE_SIZE = 50;

  constructor(props) {
    super(props);

    let userDataJson = sessionStorage.getItem("userData");
    this.userData = userDataJson
      ? JSON.parse(sessionStorage.getItem("userData"))
      : {};
    const today = new Date();
    const startDate = new Date(today.getFullYear(), today.getMonth(), 1)
      .toISOString()
      .split("T")[0];
    const endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0)
      .toISOString()
      .split("T")[0];

    this.state = {
      detalleMode: "cuenta",
      selectedAccount: null,
      selectedGroup: null,
      groupData: null,
      groupAccounts: [],
      allUserAccounts: [],
      transacciones: [],
      filteredTransacciones: [],
      showTransactionNewModal: false,
      showTransactionEditModal: false,
      showGrupoEditModal: false,
      showAccountEditModal: false,
      showTransactionDeleteAlert: false,
      selectedTransactionEdit: null,
      selectedAccountEdit: null,
      selectedTransactionDelete: null,
      loadCount: 0,
      startDate,
      endDate,
      selectedYear: today.getFullYear(),
      selectedMonth: this.months.find(
        (element) =>
          element.value === (today.getMonth() + 1).toString().padStart(2, "0")
      ),
      sortColumn: "fecha",
      sortOrder: "asc",
      showAdvancedFilters: false,
      filtroConcepto: "",
      filtroCategoria: "",
      minValue: "",
      maxValue: "",
      hiddenIncomeConcepts: {},
      hiddenExpenseCategorias: {},
      showImportModal: false,
      selectedBatch: new Set(),
      currentPage: 1,
      pageSize: 50,
      batchCategoriaId: "",
      batchFecha: "",
      batchFechaContable: "",
      showBatchDeleteAlert: false,
      editingCells: {},
      savingRows: new Set(),
      savedRows: new Set(),
      modoVista: "contable",
      showAccountingInfo: false,
      prorrateoFilter: "all",
      showResumenCard: true,
      showIncomeCard: true,
      showExpenseCard: true,
      showSidePanel: true,
      selectedGroupAccountId: "all",
      showColPicker: false,
      visibleColumns: { fecha: true, concepto: true, detalle: true, cantidad: true, categoria: true, cuenta: false },
      showConfirmarPresupuestoModal: false,
      selectedBudgetTransaction: null,
      newRows: [
        { _tempId: 'new-1', fecha: '', concepto: '', detalle: '', cantidad: '', IDCategoriaFK: null, IDCategoriaSearch: '', idCuentaOrigen: '' },
        { _tempId: 'new-2', fecha: '', concepto: '', detalle: '', cantidad: '', IDCategoriaFK: null, IDCategoriaSearch: '', idCuentaOrigen: '' },
        { _tempId: 'new-3', fecha: '', concepto: '', detalle: '', cantidad: '', IDCategoriaFK: null, IDCategoriaSearch: '', idCuentaOrigen: '' },
      ],
    };

    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.toggleFilterMode = this.toggleFilterMode.bind(this);
  }

  componentDidMount() {
    this.checkSelectedEntity();
    this.getAllCategorias();
    this.getUserAccounts();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.selectedAccount !== prevState.selectedAccount ||
      this.state.selectedGroup !== prevState.selectedGroup
    ) {
      this.getTransactions();
    }
  }

  checkSelectedEntity() {
    const location = "" + window.location;
    const accountMatch = location.match(/cuenta\/(\d+)$/);
    const groupMatch = location.match(/grupo\/(\d+)$/);

    if (accountMatch) {
      const number = parseInt(accountMatch[1], 10);
      this.setState({ detailMode: "cuenta", selectedAccount: number, selectedGroup: null });
    } else if (groupMatch) {
      const number = parseInt(groupMatch[1], 10);
      this.setState({ detailMode: "grupo", selectedGroup: number, selectedAccount: null });
    } else {
      this.setState({ selectedAccount: null, selectedGroup: null });
    }
  }

  getTransactions() {
    const isGrupo = this.state.detailMode === "grupo";
    const selectedId = isGrupo ? this.state.selectedGroup : this.state.selectedAccount;
    if (!selectedId) return;

    this.props.onLoading(true);

    const method = isGrupo
      ? "getGrupoTransactions?IDGrupo=" + selectedId
      : "getAccountTransactions?IDCuenta=" + selectedId;

    doFetch("CCON", method, null)
      .then((response) => response.json())
      .then((data) => {
        let transacciones = [];
        let groupData = null;
        let groupAccounts = [];

        if (data.STATE === "SUCCESS") {
          if (isGrupo && data.DATA) {
            groupData = data.DATA;
            groupAccounts = Array.isArray(data.DATA.cuentas) ? data.DATA.cuentas : [];
            transacciones = (data.DATA.transacciones || []).map((t) => this.normalizeTransactionDates(t));
          } else if (!isGrupo && Array.isArray(data.DATA)) {
            transacciones = data.DATA.map((t) => this.normalizeTransactionDates(t));
          }
        }

        this.setState({
          transacciones,
          groupData,
          groupAccounts,
          selectedGroupAccountId: this.state.selectedGroupAccountId || "all",
          newRows: this.state.newRows.map((row) => ({
            ...row,
            idCuentaOrigen: isGrupo
              ? (this.state.selectedGroupAccountId !== "all"
                  ? this.state.selectedGroupAccountId
                  : (groupAccounts[0]?.IDCuenta || ""))
              : "",
          })),
        }, () => {
          this.filterTransactions();
        });
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }

  getUserAccounts() {
    doFetch("CCON", "getUserAccounts", null)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS" && Array.isArray(data.DATA)) {
          // Aplanar igual que MisCuentas: extraer la cuenta de IDCuentaFK y deduplicar
          const accountMap = new Map();
          for (const row of data.DATA) {
            const cuenta = row.IDCuentaFK;
            if (cuenta && !accountMap.has(cuenta.IDCuenta)) {
              accountMap.set(cuenta.IDCuenta, cuenta);
            }
          }
          this.setState({ allUserAccounts: Array.from(accountMap.values()) });
        }
      })
      .catch(() => {});
  }

  setNewTransaction() {
    this.setState({ showTransactionNewModal: true });
    //today.setDate(today.getDate() + 1);
  }

  setEditTransaction(element) {
    const accountId = this.state.detailMode === "grupo"
      ? Number(element?.idCuentaOrigen || this.state.groupAccounts?.[0]?.IDCuenta)
      : this.state.selectedAccount;
    const editData = {
      ...element,
      cuentas: [{ participacion: 100, IDCuentaFK: { IDCuenta: accountId } }],
      usuarios: element?.usuarios || [{ participacion: 100, IDUsuarioFK: { IDUsuario: this.userData.IDUsuario } }],
    };
    this.setState({
      showTransactionEditModal: true,
      selectedTransactionEdit: editData,
    });
  }

  handleCloseModal() {
    this.setState({
      showTransactionEditModal: false,
      showTransactionNewModal: false,
    });
    this.getTransactions();
  }

  confirmTransactionDelete(element) {
    this.setState({
      showTransactionDeleteAlert: true,
      selectedTransactionDelete: element,
    });
  }

  async handlerConfirmDeleteTransaction() {
    this.setState({ showTransactionDeleteAlert: false });
    let res = await this.deleteTransaction();
    if (res) {
      this.getTransactions();
    }
  }

  handlerCancelDeleteTransaction() {
    this.setState({
      showTransactionDeleteAlert: false,
      selectedTransactionDelete: null,
    });
  }

  async deleteTransaction() {
    let result = false;

    this.props.onLoading(true);

    const requestOptions = {
      method: "DELETE",
    };

    this.props.onLoading(true);
    let method =
      "deleteTransactions?IDTransaccion=" +
      this.state.selectedTransactionDelete.IDTransaccion;

    await doFetch("CCON", method, requestOptions)
      .then((response) => response.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  formatCurrency(value, locale = "es-ES", currency = "EUR", options = {}) {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
      ...options,
    }).format(value);
  }

  normalizeIncomeFlag(value) {
    return value === true || value === 1 || value === "1";
  }

  resolveCategoriaMeta(transaction) {
    const embeddedCategory = transaction?.IDCategoriaFK;
    const embeddedId = embeddedCategory?.IDCategoria;
    const embeddedName = (embeddedCategory?.nombre || "").trim().toLowerCase();
    const mappedCategory = (this.mapaCategorias || []).find((categoria) => {
      if (embeddedId != null && String(categoria.IDCategoria) === String(embeddedId)) {
        return true;
      }
      return embeddedName && (categoria.nombre || "").trim().toLowerCase() === embeddedName;
    });
    return mappedCategory || embeddedCategory || null;
  }

  isIncomeTransaction(transaction) {
    const categoria = this.resolveCategoriaMeta(transaction);
    return this.normalizeIncomeFlag(categoria?.esIngreso);
  }

  getTransactionSummaryTotals(transactions = []) {
    return transactions.reduce(
      (acc, transaction) => {
        const amount = Number(transaction?.cantidad) || 0;
        if (this.isIncomeTransaction(transaction)) {
          acc.ingresos += Math.abs(amount);
          acc.balance += Math.abs(amount);
        } else {
          acc.gastosSigned += amount;
          acc.balance -= Math.abs(amount);
        }
        return acc;
      },
      { ingresos: 0, gastosSigned: 0, balance: 0 }
    );
  }

  formatearFecha(fechaISO, formato = "DD/MM/AAAA") {
    if (fechaISO === null || fechaISO === undefined || fechaISO === "") {
      return "";
    }

    const fechaLimpia = String(fechaISO).replace("[UTC]", "");

    // Crear un objeto Date a partir de la cadena de fecha limpia
    const fecha = new Date(fechaLimpia);

    // Verificar si la fecha es válida
    if (isNaN(fecha)) {
      return "";
    }

    // Obtener el día, el mes y el año
    const dia = fecha.getDate().toString().padStart(2, "0");
    const mes = (fecha.getMonth() + 1).toString().padStart(2, "0");
    const ano = fecha.getFullYear();

    switch (formato) {
      case "DD/MM/AAAA":
        return `${dia}/${mes}/${ano}`;
      case "AAAA-MM-DD":
        return `${ano}-${mes}-${dia}`;
      case "MM/DD/AAAA":
        return `${mes}/${dia}/${ano}`;
      case "AAAA/DD/MM":
        return `${ano}/${dia}/${mes}`;
      default:
        return `${dia}/${mes}/${ano}`; // Formato por defecto
    }
  }

  normalizeDateValue(value) {
    if (value === null || value === undefined || value === "") {
      return null;
    }

    if (value instanceof Date) {
      if (isNaN(value.getTime())) return null;
      return new Date(
        value.getFullYear(),
        value.getMonth(),
        value.getDate(),
        12,
        0,
        0,
        0
      );
    }

    const txt = String(value).replace("[UTC]", "").trim();
    if (!txt) return null;

    // Soporta YYYY-MM (input type=month), usando día 1
    const monthMatch = txt.match(/^(\d{4})-(\d{2})$/);
    if (monthMatch) {
      const [, year, month] = monthMatch;
      return new Date(Number(year), Number(month) - 1, 1, 12, 0, 0, 0);
    }

    // Soporta YYYY-MM-DD (o prefijos equivalentes)
    const dayMatch = txt.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dayMatch) {
      const [, year, month, day] = dayMatch;
      return new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0, 0);
    }

    const parsed = new Date(txt);
    if (isNaN(parsed.getTime())) return null;
    return new Date(
      parsed.getFullYear(),
      parsed.getMonth(),
      parsed.getDate(),
      12,
      0,
      0,
      0
    );
  }

  toDateKey(dateObj) {
    if (!(dateObj instanceof Date) || isNaN(dateObj.getTime())) return "";
    return `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${String(
      dateObj.getDate()
    ).padStart(2, "0")}`;
  }

  toAccountingMonthStart(dateValue) {
    const normalized = this.normalizeDateValue(dateValue);
    if (!normalized) return null;
    return new Date(
      normalized.getFullYear(),
      normalized.getMonth(),
      1,
      12,
      0,
      0,
      0
    );
  }

  getDefaultAccountingDateFromState() {
    const { selectedYear, selectedMonth } = this.state;
    const year = Number(selectedYear) || new Date().getFullYear();
    const monthFromState = selectedMonth?.value;
    const month = monthFromState && monthFromState !== "00"
      ? Number(monthFromState)
      : new Date().getMonth() + 1;
    return new Date(year, month - 1, 1, 12, 0, 0, 0);
  }

  normalizeTransactionDates(transaction) {
    const bankDate = this.normalizeDateValue(transaction?.fecha);
    let accountingDate = this.toAccountingMonthStart(transaction?.fechaImputacion);

    // Si no hay fecha normal, debe existir fecha contable al menos.
    if (!bankDate && !accountingDate) {
      accountingDate = this.getDefaultAccountingDateFromState();
    }

    return {
      ...transaction,
      fecha: bankDate ? this.toDateKey(bankDate) : null,
      fechaImputacion: accountingDate
        ? this.toDateKey(accountingDate)
        : (transaction?.fechaImputacion ?? null),
    };
  }

  getBankDate(transaction) {
    return this.normalizeDateValue(transaction?.fecha);
  }

  getAccountingDate(transaction) {
    const accounting = this.toAccountingMonthStart(transaction?.fechaImputacion);
    if (accounting) return accounting;
    return this.getBankDate(transaction);
  }

  getDateForFiltering(transaction, modoVista) {
    if (modoVista === "bancaria") {
      return this.getBankDate(transaction) || this.getAccountingDate(transaction);
    }
    return this.getAccountingDate(transaction) || this.getBankDate(transaction);
  }

  ensureDatePayload(data) {
    const fecha = this.normalizeDateValue(data?.fecha);
    let fechaImputacion = this.toAccountingMonthStart(data?.fechaImputacion);

    // Si no hay fecha normal, se fuerza fecha contable.
    if (!fecha && !fechaImputacion) {
      fechaImputacion = this.getDefaultAccountingDateFromState();
    }

    return {
      fecha,
      fechaImputacion,
    };
  }

  getYearMonth(value) {
    const normalized = this.normalizeDateValue(value);
    if (!normalized) return "";
    return `${normalized.getFullYear()}-${String(
      normalized.getMonth() + 1
    ).padStart(2, "0")}`;
  }

  sortTransactions(column) {
    const { sortColumn, sortOrder, filteredTransacciones } = this.state;
    let newSortOrder = "asc";

    if (sortColumn === column && sortOrder === "asc") {
      newSortOrder = "desc";
    }

    const sortedTransacciones = this.sortTransactionsList(
      filteredTransacciones,
      column,
      newSortOrder,
      this.state.modoVista
    );

    this.setState({
      filteredTransacciones: sortedTransacciones,
      sortColumn: column,
      sortOrder: newSortOrder,
    });
  }

  sortTransactionsList(transacciones, column, sortOrder, modoVista = "bancaria") {
    return [...transacciones].sort((a, b) => {
      let aValue, bValue;
      if (column === "fecha") {
        // Regla funcional: la tabla siempre se ordena por fecha normal.
        // Si falta fecha normal, usar fecha contable para no dejar filas ocultas por paginación.
        const aDate = this.getBankDate(a) || this.getAccountingDate(a);
        const bDate = this.getBankDate(b) || this.getAccountingDate(b);
        aValue = aDate ? aDate.getTime() : Number.POSITIVE_INFINITY;
        bValue = bDate ? bDate.getTime() : Number.POSITIVE_INFINITY;
      } else if (column === "cantidad") {
        aValue = a[column];
        bValue = b[column];
      } else {
        aValue = (a.IDCategoriaFK?.nombre ?? "").toLowerCase();
        bValue = (b.IDCategoriaFK?.nombre ?? "").toLowerCase();
      }

      if (aValue < bValue) {
        return sortOrder === "asc" ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortOrder === "asc" ? 1 : -1;
      }
      return 0;
    });
  }

  handleStartDateChange(event) {
    this.setState({ startDate: event.target.value }, this.filterTransactions);
  }

  handleEndDateChange(event) {
    this.setState({ endDate: event.target.value }, this.filterTransactions);
  }

  handleYearChange(event) {
    const selectedYear = event.target.value;
    this.setState({ selectedYear }, this.filterTransactions);
  }

  handleMonthChange(month) {
    this.setState({ selectedMonth: month }, this.filterTransactions);
  }

  filterTransactions() {
    const {
      transacciones,
      startDate,
      endDate,
      selectedYear,
      selectedMonth,
      sortColumn,
      sortOrder,
      showAdvancedFilters,
      filtroConcepto,
      filtroCategoria,
      minValue,
      maxValue,
      modoVista,
      prorrateoFilter,
      selectedGroupAccountId,
    } = this.state;
    let filteredTransacciones = Array.isArray(transacciones) ? transacciones : [];

    if (showAdvancedFilters) {
      const comparisonStartDate = new Date(startDate);
      const comparisonEndDate = new Date(endDate);
      comparisonEndDate.setHours(23, 59, 59, 999);

      filteredTransacciones = filteredTransacciones.filter((transaction) => {
        const transactionDate = this.getDateForFiltering(transaction, modoVista);
        const matchesDate = !transactionDate || (() => {
          return transactionDate >= comparisonStartDate && transactionDate <= comparisonEndDate;
        })();
        const matchesConcept = transaction.concepto
          .toLowerCase()
          .includes(filtroConcepto.toLowerCase());
        const matchesCategoria = (transaction.IDCategoriaFK?.nombre ?? "")
          .toLowerCase()
          .includes(filtroCategoria.toLowerCase());
        return (
          matchesDate &&
          matchesConcept &&
          matchesCategoria
        );
      });
    } else {
      const year = parseInt(selectedYear);
      let comparisonStartDate = new Date(`${year}-01-01`);
      let comparisonEndDate = new Date(`${year}-12-31`);

      if (selectedMonth && selectedMonth.value !== "00") {
        const month = selectedMonth.value.padStart(2, "0");
        comparisonStartDate = new Date(`${year}-${month}-01`);
        comparisonEndDate = new Date(year, Number(month), 0);
      }
      comparisonEndDate.setHours(23, 59, 59, 999);

      filteredTransacciones = filteredTransacciones.filter((transaction) => {
        const transactionDate = this.getDateForFiltering(transaction, modoVista);
        const matchesDate = !transactionDate || (() => {
          return transactionDate >= comparisonStartDate && transactionDate <= comparisonEndDate;
        })();
        const matchesConcept = transaction.concepto
          .toLowerCase()
          .includes(filtroConcepto.toLowerCase());
        const matchesCategoria = (transaction.IDCategoriaFK?.nombre ?? "")
          .toLowerCase()
          .includes(filtroCategoria.toLowerCase());
        return (
          matchesDate &&
          matchesConcept &&
          matchesCategoria
        );
      });
    }

    if (filtroConcepto) {
      filteredTransacciones = filteredTransacciones.filter((transaction) =>
        transaction.concepto
          .toLowerCase()
          .includes(filtroConcepto.toLowerCase())
      );
    }

    if (filtroCategoria) {
      filteredTransacciones = filteredTransacciones.filter((transaction) =>
        (transaction.IDCategoriaFK?.nombre ?? "")
          .toLowerCase()
          .includes(filtroCategoria.toLowerCase())
      );
    }

    if (minValue || maxValue) {
      const minVal = minValue ? parseFloat(minValue) : -Infinity;
      const maxVal = maxValue ? parseFloat(maxValue) : Infinity;

      filteredTransacciones = filteredTransacciones.filter((transaction) => {
        const value = parseFloat(transaction.cantidad);
        return value >= minVal && value <= maxVal;
      });
    }

    if (prorrateoFilter !== "all") {
      filteredTransacciones = filteredTransacciones.filter((transaction) => {
        const isProrrateada =
          transaction.IDProrrateoFK !== null &&
          transaction.IDProrrateoFK !== undefined &&
          Number(transaction.numCuota || 0) > 0;

        if (prorrateoFilter === "prorrateadas") {
          return isProrrateada;
        }
        if (prorrateoFilter === "no_prorrateadas") {
          return !isProrrateada;
        }
        return true;
      });
    }

    if (this.state.detailMode === "grupo" && selectedGroupAccountId !== "all") {
      filteredTransacciones = filteredTransacciones.filter(
        (transaction) => String(transaction.idCuentaOrigen) === String(selectedGroupAccountId)
      );
    }

    const sorted = this.sortTransactionsList(
      filteredTransacciones,
      sortColumn || "fecha",
      sortOrder || "asc",
      modoVista
    );

    this.setState({ filteredTransacciones: sorted, currentPage: 1, selectedBatch: new Set() });
  }

  adjustYear(amount) {
    this.setState(
      (prevState) => ({
        selectedYear: prevState.selectedYear + amount,
      }),
      this.filterTransactions
    );
  }

  adjustMonth(amount) {
    this.setState((prevState) => {
      let monthNum = parseInt(prevState.selectedMonth.value, 10);
      let year = prevState.selectedYear;

      if (monthNum === 0) {
        monthNum = amount > 0 ? 1 : 12;
      } else {
        monthNum += amount;
        if (monthNum > 12) {
          monthNum = 1;
          year += 1;
        } else if (monthNum < 1) {
          monthNum = 12;
          year -= 1;
        }
      }

      const selectedMonth = this.months.find(
        (m) => m.value === String(monthNum).padStart(2, "0")
      );
      return { selectedYear: year, selectedMonth };
    }, this.filterTransactions);
  }

  toggleFilterMode() {
    this.setState(
      (prevState) => ({
        showAdvancedFilters: !prevState.showAdvancedFilters,
      }),
      this.filterTransactions
    );
  }

  valorMinimo(event) {
    const { value } = event.target;
    const regex = /^-?\d*(?:.\d{0,2})?$/;

    if (regex.test(value)) {
      this.setState({ minValue: value }, this.filterTransactions);
    }
  }

  valorMaximo(event) {
    const { value } = event.target;
    const regex = /^-?\d*(?:.\d{0,2})?$/;

    if (regex.test(value)) {
      this.setState({ maxValue: value }, this.filterTransactions);
    }
  }

  colorFromText(text, saturation = 70, lightness = 50) {
    const input = String(text || "sin-dato");
    let hash = 0;
    for (let i = 0; i < input.length; i += 1) {
      hash = input.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = Math.abs(hash) % 360;
    return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
  }

  getResumenPorCategorias(transactions = []) {
    const resumenMap = transactions.reduce((acc, transaction) => {
      const categoria = this.resolveCategoriaMeta(transaction);
      const nombreCategoria = categoria?.nombre || "Sin categoria";
      const tipo = this.isIncomeTransaction(transaction) ? "Ingreso" : "Gasto";
      const amount = Number(transaction?.cantidad) || 0;

      if (!acc[nombreCategoria]) {
        acc[nombreCategoria] = { categoria: nombreCategoria, tipo, totalSigned: 0 };
      }
      acc[nombreCategoria].tipo = tipo;
      acc[nombreCategoria].totalSigned += amount;
      return acc;
    }, {});

    return Object.values(resumenMap).sort((a, b) => Math.abs(b.totalSigned) - Math.abs(a.totalSigned));
  }

  toggleSideCard = (cardKey) => {
    this.setState((prevState) => ({ [cardKey]: !prevState[cardKey] }));
  };

  toggleIncomeLegendItem = (concepto) => {
    this.setState((prevState) => ({
      hiddenIncomeConcepts: {
        ...prevState.hiddenIncomeConcepts,
        [concepto]: !prevState.hiddenIncomeConcepts[concepto],
      },
    }));
  };

  toggleExpenseLegendItem = (categoria) => {
    this.setState((prevState) => ({
      hiddenExpenseCategorias: {
        ...prevState.hiddenExpenseCategorias,
        [categoria]: !prevState.hiddenExpenseCategorias[categoria],
      },
    }));
  };

  buildIncomeDonutModel(transactions = []) {
    const grouped = transactions.reduce((acc, transaction) => {
      if (!this.isIncomeTransaction(transaction)) return acc;
      const concepto = String(transaction?.concepto || "Sin concepto").trim() || "Sin concepto";
      const amount = Math.abs(Number(transaction?.cantidad) || 0);
      acc[concepto] = (acc[concepto] || 0) + amount;
      return acc;
    }, {});

    const rows = Object.entries(grouped)
      .map(([label, value]) => ({ label, value }))
      .sort((a, b) => b.value - a.value);

    const visibleRows = rows.filter((row) => !this.state.hiddenIncomeConcepts[row.label]);
    return {
      rows,
      chartData: {
        labels: visibleRows.map((row) => row.label),
        datasets: [
          {
            data: visibleRows.map((row) => row.value),
            backgroundColor: visibleRows.map((row) => this.colorFromText(row.label)),
            borderWidth: 1,
          },
        ],
      },
    };
  }

  buildExpenseDonutModel(transactions = []) {
    const grouped = transactions.reduce((acc, transaction) => {
      if (this.isIncomeTransaction(transaction)) return acc;
      const categoria = this.resolveCategoriaMeta(transaction);
      const label = String(categoria?.nombre || "Sin categoria").trim() || "Sin categoria";
      const amount = Math.abs(Number(transaction?.cantidad) || 0);
      acc[label] = (acc[label] || 0) + amount;
      return acc;
    }, {});

    const rows = Object.entries(grouped)
      .map(([label, value]) => ({ label, value }))
      .sort((a, b) => b.value - a.value);

    const visibleRows = rows.filter((row) => !this.state.hiddenExpenseCategorias[row.label]);
    return {
      rows,
      chartData: {
        labels: visibleRows.map((row) => row.label),
        datasets: [
          {
            data: visibleRows.map((row) => row.value),
            backgroundColor: visibleRows.map((row) => this.colorFromText(row.label, 68, 47)),
            borderWidth: 1,
          },
        ],
      },
    };
  }

  parseImportDate(value) {
    if (!value) return null;
    if (value instanceof Date && !isNaN(value.getTime())) return value;

    const txt = String(value).trim();
    if (!txt) return null;

    // Excel serial date
    if (/^\d+(\.\d+)?$/.test(txt)) {
      const n = Number(txt);
      if (n > 20000 && n < 100000) {
        const base = new Date(Date.UTC(1899, 11, 30));
        base.setUTCDate(base.getUTCDate() + Math.floor(n));
        return new Date(base.getUTCFullYear(), base.getUTCMonth(), base.getUTCDate(), 12, 0, 0, 0);
      }
    }

    if (txt.includes("/")) {
      const p = txt.split("/");
      if (p.length === 3) {
        const [d, m, y] = p;
        const dt = new Date(Number(y), Number(m) - 1, Number(d), 12, 0, 0, 0);
        if (!isNaN(dt.getTime())) return dt;
      }
    }

    const dateOnlyMatch = txt.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dateOnlyMatch) {
      const [, year, month, day] = dateOnlyMatch;
      const dt = new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0, 0);
      if (!isNaN(dt.getTime())) return dt;
    }

    const iso = new Date(txt);
    if (!isNaN(iso.getTime())) return iso;

    return null;
  }

  getRowValue(row, aliases) {
    const keys = Object.keys(row || {});
    for (const alias of aliases) {
      const k = keys.find((x) => x.toLowerCase() === alias.toLowerCase());
      if (k && row[k] !== undefined && row[k] !== null) return row[k];
    }
    return "";
  }

  normalizeImportRows(rows) {
    return (rows || []).map((row) => {
      const fecha = this.getRowValue(row, ["Fecha", "fecha", "date"]);
      const fechaImputacion = this.getRowValue(row, ["FechaContable", "fechaContable", "fechaImputacion", "Fecha_Imputacion"]);
      const concepto = this.getRowValue(row, ["Concepto", "concepto", "description"]);
      const detalle = this.getRowValue(row, ["Detalle", "detalle", "detail"]);
      const cantidadRaw = this.getRowValue(row, ["Cantidad", "cantidad", "importe", "amount"]);
      const categoria = this.getRowValue(row, ["Categoria", "Categoría", "categoria", "category"]);

      return {
        fecha,
        fechaImputacion,
        concepto: String(concepto || "").trim(),
        detalle: String(detalle || "").trim(),
        cantidad: String(cantidadRaw || "").replace(",", ".").trim(),
        categoria: String(categoria || "").trim(),
      };
    });
  }

  parseImportAmount(value) {
    if (value === null || value === undefined) return NaN;
    if (typeof value === "number") return value;

    let txt = String(value).trim();
    if (!txt) return NaN;

    txt = txt
      .replace(/€/g, "")
      .replace(/\s/g, "")
      .replace(/[^0-9,.-]/g, "");

    const hasComma = txt.includes(",");
    const hasDot = txt.includes(".");

    if (hasComma && hasDot) {
      txt = txt.replace(/\./g, "").replace(",", ".");
    } else if (hasComma) {
      txt = txt.replace(",", ".");
    }

    return Number(txt);
  }

  toLocalNoonDate(value) {
    if (!value) return null;
    if (value instanceof Date) {
      return new Date(
        value.getFullYear(),
        value.getMonth(),
        value.getDate(),
        12,
        0,
        0,
        0
      );
    }
    return this.parseImportDate(value);
  }

  async processImportedRows(rows) {
    const normalized = this.normalizeImportRows(rows);
    if (!normalized.length) {
      alert("No hay filas para importar");
      return;
    }

    await this.getAllCategorias();
    const transacciones = [];

    for (const fila of normalized) {
      if (!fila.concepto || !fila.cantidad) continue;

      const fechaTexto = String(fila.fecha || "").trim();
      const fechaConvertida = fechaTexto ? this.parseImportDate(fila.fecha) : null;
      const fechaImputacionConvertida = fila.fechaImputacion ? this.toAccountingMonthStart(fila.fechaImputacion) : null;
      const cantidad = this.parseImportAmount(fila.cantidad);
      if ((fechaTexto && !fechaConvertida) || isNaN(cantidad)) continue;

      transacciones.push({
        fecha: fechaConvertida,
        fechaImputacion: fechaImputacionConvertida,
        detalle: fila.detalle,
        concepto: fila.concepto,
        cantidad,
        IDCategoriaFK: {
          IDCategoria: fila.categoria ? await this.obtenerIDCategoria(fila.categoria) : null,
        },
        cuentas: [
          {
            participacion: 100,
            IDCuentaFK: {
              IDCuenta: this.state.selectedAccount,
            },
          },
        ],
        usuarios: [
          {
            participacion: 100,
            IDUsuarioFK: {
              IDUsuario: this.userData.IDUsuario,
            },
          },
        ],
      });
    }

    if (!transacciones.length) {
      alert("No se detectaron filas válidas para importar");
      return;
    }

    const ok = await this.insertTransaction(transacciones);
    if (ok) {
      this.getTransactions();
      alert(`Importadas ${transacciones.length} transacción(es)`);
    }
  }

  async handleFileUpload(event) {
    const file = event.target.files[0];

    if (file) {
      try {
        const ext = (file.name.split(".").pop() || "").toLowerCase();

        if (ext === "csv") {
          const text = await file.text();
          const parsed = Papa.parse(text, { header: true, skipEmptyLines: true });
          await this.processImportedRows(parsed.data);
        } else if (ext === "json") {
          const text = await file.text();
          const json = JSON.parse(text);
          await this.processImportedRows(Array.isArray(json) ? json : []);
        } else if (ext === "xlsx" || ext === "xls") {
          const ab = await file.arrayBuffer();
          const wb = XLSX.read(ab, { type: "array" });
          const ws = wb.Sheets[wb.SheetNames[0]];
          const rows = XLSX.utils.sheet_to_json(ws, { defval: "" });
          await this.processImportedRows(rows);
        } else {
          alert("Formato no soportado. Usa CSV, JSON o Excel (.xlsx/.xls)");
        }
      } catch (e) {
        console.error("Error importando fichero:", e);
        alert("No se pudo importar el fichero");
      } finally {
        event.target.value = "";
      }
    }
  }

  toGoogleSheetCsvUrl(url) {
    try {
      const u = new URL(url);
      const m = u.pathname.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
      if (!m) return null;
      const id = m[1];
      const gid = u.searchParams.get("gid") || "0";
      return `https://docs.google.com/spreadsheets/d/${id}/export?format=csv&gid=${gid}`;
    } catch (e) {
      return null;
    }
  }

  importFromGoogleSheet = async () => {
    const url = window.prompt("Pega la URL de Google Sheets (hoja publicada o accesible):");
    if (!url) return;

    const csvUrl = this.toGoogleSheetCsvUrl(url);
    if (!csvUrl) {
      alert("URL de Google Sheets no válida");
      return;
    }

    try {
      this.props.onLoading(true);
      const res = await fetch(csvUrl);
      const text = await res.text();
      const parsed = Papa.parse(text, { header: true, skipEmptyLines: true });
      await this.processImportedRows(parsed.data);
    } catch (e) {
      console.error("Error importando Google Sheet:", e);
      alert("No se pudo importar desde Google Sheets");
    } finally {
      this.props.onLoading(false);
    }
  };

  getExportRows() {
    return (this.state.filteredTransacciones || [])
      .filter((t) => !t.esVirtual)
      .map((t) => ({
        Fecha: this.formatearFecha(t.fecha),
        Concepto: t.concepto || "",
        Detalle: t.detalle || "",
        Cantidad: t.cantidad,
        Categoria: t.IDCategoriaFK?.nombre || "",
      }));
  }

  triggerDownload(content, fileName, mimeType) {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  exportAsCSV = () => {
    const rows = this.getExportRows();
    const csv = Papa.unparse(rows);
    this.triggerDownload(csv, `gastos_${this.state.selectedAccount || "cuenta"}.csv`, "text/csv;charset=utf-8;");
  };

  exportAsJSON = () => {
    const rows = this.getExportRows();
    const json = JSON.stringify(rows, null, 2);
    this.triggerDownload(json, `gastos_${this.state.selectedAccount || "cuenta"}.json`, "application/json;charset=utf-8;");
  };

  exportAsExcel = () => {
    const rows = this.getExportRows();
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Gastos");
    XLSX.writeFile(wb, `gastos_${this.state.selectedAccount || "cuenta"}.xlsx`);
  };

  exportToGoogleSheet = () => {
    this.exportAsCSV();
    window.open("https://docs.google.com/spreadsheets/u/0/", "_blank");
    alert("CSV descargado. En Google Sheets: Archivo > Importar > Subir el CSV.");
  };

  async obtenerIDCategoria(nombreCategoria) {
    for (let categoria of this.mapaCategorias) {
      if (categoria.nombre === nombreCategoria) {
        return categoria.IDCategoria;
      }
    }
  }

  async insertTransaction(transacciones) {
    let result = false;

    this.props.onLoading(true);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(transacciones),
    };

    await doFetch("CCON", "insertTransactions", requestOptions)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          result = true;
        }
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });

    return result;
  }

  toggleBatchItem(id) {
    this.setState((prev) => {
      const next = new Set(prev.selectedBatch);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return { selectedBatch: next };
    });
  }

  toggleSelectAll() {
    const { filteredTransacciones, selectedBatch, currentPage } = this.state;
    const page = filteredTransacciones.slice((currentPage - 1) * this.PAGE_SIZE, currentPage * this.PAGE_SIZE);
    const selectable = page.filter((t) => !t.esVirtual).map((t) => t.IDTransaccion);
    const allSelected = selectable.every((id) => selectedBatch.has(id));
    this.setState((prev) => {
      const next = new Set(prev.selectedBatch);
      if (allSelected) selectable.forEach((id) => next.delete(id));
      else selectable.forEach((id) => next.add(id));
      return { selectedBatch: next };
    });
  }

  async handleBatchDelete() {
    this.setState({ showBatchDeleteAlert: false });
    const ids = [...this.state.selectedBatch];
    this.props.onLoading(true);
    await Promise.all(
      ids.map((id) =>
        doFetch("CCON", `deleteTransactions?IDTransaccion=${id}`, { method: "DELETE" }).catch(console.error)
      )
    );
    this.setState({ selectedBatch: new Set(), currentPage: 1 });
    this.props.onLoading(false);
    this.getTransactions();
  }

  async handleBatchChangeCategory() {
    const { selectedBatch, batchCategoriaId } = this.state;
    if (!batchCategoriaId) return;
    this.props.onLoading(true);
    const opts = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ IDTransacciones: [...selectedBatch], IDCategoria: parseInt(batchCategoriaId) }),
    };
    await doFetch("CCON", "batchUpdateCategoria", opts).catch(console.error);
    this.setState({ selectedBatch: new Set(), batchCategoriaId: "" });
    this.props.onLoading(false);
    this.getTransactions();
  }

  getCurrentVisibleMonthValue() {
    const { selectedYear, selectedMonth } = this.state;
    if (selectedMonth && selectedMonth.value && selectedMonth.value !== "00") {
      return `${selectedYear}-${selectedMonth.value}`;
    }
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  }

  async handleBatchChangeDates({ useFecha = false, useFechaContable = false } = {}) {
    const { selectedBatch, batchFecha, batchFechaContable } = this.state;
    if (selectedBatch.size === 0) return;
    if (useFecha && !batchFecha) return;
    if (useFechaContable && !batchFechaContable) return;

    const body = { IDTransacciones: [...selectedBatch] };
    if (useFecha) {
      body.Fecha = batchFecha;
    }
    if (useFechaContable) {
      body.FechaImputacion = `${batchFechaContable}-01`;
    }

    this.props.onLoading(true);
    await doFetch("CCON", "batchUpdateFechas", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).catch(console.error);

    this.setState({
      selectedBatch: new Set(),
      batchCategoriaId: "",
      batchFecha: "",
      batchFechaContable: "",
      currentPage: 1,
    });
    this.props.onLoading(false);
    this.getTransactions();
  }

  async handleBatchQuickAccountingVisibleMonth() {
    const monthValue = this.getCurrentVisibleMonthValue();
    this.setState({ batchFechaContable: monthValue }, () => {
      this.handleBatchChangeDates({ useFechaContable: true });
    });
  }

  async getAllCategorias() {
    this.props.onLoading(true);

    await doFetch("CCON", "getAllCategorias", null)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.mapaCategorias = (data.DATA || []).map((categoria) => ({
          ...categoria,
          esIngreso: this.normalizeIncomeFlag(categoria?.esIngreso),
        }));
        this.setState((prev) => ({ loadCount: prev.loadCount + 1 }));
      })
      .catch((error) => {
        console.error(
          "Error al obtener datos:",
          JSON.stringify(error, null, 2)
        );
      })
      .finally(() => {
        this.props.onLoading(false);
      });
  }


  // ── Fase 7: Inline editing ──────────────────────────────
  handleCellChange = (id, field, value) => {
    this.setState(prev => ({
      editingCells: { ...prev.editingCells, [`${id}-${field}`]: value }
    }));
    clearTimeout(this.saveTimers[id]);
    this.saveTimers[id] = setTimeout(() => this.saveExistingRow(id), 800);
  };

  getCategoryByName = (name) => {
    const n = (name || '').trim().toLowerCase();
    return (this.mapaCategorias || []).find((c) => (c.nombre || '').toLowerCase() === n);
  };

  getCategoriaSuggestions = (query) => {
    const q = (query || '').trim().toLowerCase();
    const all = this.mapaCategorias || [];
    const filtered = q
      ? all.filter((c) => (c.nombre || '').toLowerCase().includes(q))
      : all;
    return filtered.slice(0, 6);
  };

  hexToRgba = (hex, alpha = 0.12) => {
    if (!hex || typeof hex !== 'string') return `rgba(18, 102, 241, ${alpha})`;
    let h = hex.replace('#', '').trim();
    if (h.length === 3) {
      h = h.split('').map((x) => x + x).join('');
    }
    if (!/^[0-9a-fA-F]{6}$/.test(h)) return `rgba(18, 102, 241, ${alpha})`;
    const r = parseInt(h.slice(0, 2), 16);
    const g = parseInt(h.slice(2, 4), 16);
    const b = parseInt(h.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  handleCategorySearchChange = (id, value) => {
    const match = this.getCategoryByName(value);
    this.setState((prev) => {
      const editingCells = {
        ...prev.editingCells,
        [`${id}-IDCategoriaSearch`]: value,
      };
      if (match) {
        editingCells[`${id}-IDCategoriaFK`] = String(match.IDCategoria);
      } else if ((value || '').trim() === '') {
        editingCells[`${id}-IDCategoriaFK`] = '';
      }
      return { editingCells };
    });

    if (match || (value || '').trim() === '') {
      clearTimeout(this.saveTimers[id]);
      this.saveTimers[id] = setTimeout(() => this.saveExistingRow(id), 800);
    }
  };

  handleNewRowCategorySearch = (tempId, value) => {
    const match = this.getCategoryByName(value);
    this.setState((prev) => ({
      newRows: prev.newRows.map((r) =>
        r._tempId === tempId
          ? {
              ...r,
              IDCategoriaSearch: value,
              IDCategoriaFK: match ? String(match.IDCategoria) : null,
            }
          : r
      ),
    }));
  };

  saveExistingRow = async (id) => {
    const { transacciones, editingCells } = this.state;
    const original = transacciones.find(t => t.IDTransaccion === id);
    if (!original) return;

    const idCatEdited = editingCells[`${id}-IDCategoriaFK`];
    const fechaEdited = editingCells[`${id}-fecha`];
    const cantidadEdited = editingCells[`${id}-cantidad`];
    const concepto = editingCells[`${id}-concepto`] ?? original.concepto;
    const detalle = editingCells[`${id}-detalle`] ?? original.detalle ?? '';
    const cantidad = cantidadEdited !== undefined ? parseFloat(cantidadEdited) : original.cantidad;
    const fechaRaw = fechaEdited !== undefined
      ? this.toLocalNoonDate(fechaEdited)
      : this.toLocalNoonDate(original.fecha ? String(original.fecha).replace('[UTC]', '') : null);

    if (!concepto || isNaN(cantidad)) return;

    let idCat = original.IDCategoriaFK?.IDCategoria ?? null;
    if (idCatEdited !== undefined) idCat = idCatEdited ? parseInt(idCatEdited) : null;

    const { fecha, fechaImputacion } = this.ensureDatePayload({
      fecha: fechaRaw,
      fechaImputacion: original.fechaImputacion,
    });

    const accountForRow = this.state.detailMode === "grupo"
      ? Number(original.idCuentaOrigen || this.state.selectedGroupAccountId || this.state.groupAccounts?.[0]?.IDCuenta)
      : this.state.selectedAccount;

    const payload = {
      ...original,
      fecha,
      fechaImputacion,
      concepto,
      detalle,
      cantidad,
      IDCategoriaFK: idCat ? { IDCategoria: idCat } : null,
      cuentas: original.cuentas ?? [{ participacion: 100, IDCuentaFK: { IDCuenta: accountForRow } }],
      usuarios: original.usuarios ?? [{ participacion: 100, IDUsuarioFK: { IDUsuario: this.userData.IDUsuario } }],
    };

    this.setState(prev => {
      const savingNext = new Set(prev.savingRows); savingNext.add(id);
      const savedNext = new Set(prev.savedRows); savedNext.delete(id);
      return { savingRows: savingNext, savedRows: savedNext };
    });

    try {
      const res = await doFetch('CCON', 'updateTransactions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify([payload]),
      }).then(r => r.json());

      if (res.STATE === 'SUCCESS') {
        this.setState(prev => {
          const savingNext = new Set(prev.savingRows); savingNext.delete(id);
          const savedNext = new Set(prev.savedRows); savedNext.add(id);
          const newCells = { ...prev.editingCells };
          Object.keys(newCells).forEach(k => { if (k.startsWith(`${id}-`)) delete newCells[k]; });
          return { savingRows: savingNext, savedRows: savedNext, editingCells: newCells };
        });
        this.getTransactions();
        setTimeout(() => {
          this.setState(prev => { const next = new Set(prev.savedRows); next.delete(id); return { savedRows: next }; });
        }, 1500);
      } else {
        this.setState(prev => { const next = new Set(prev.savingRows); next.delete(id); return { savingRows: next }; });
      }
    } catch (e) {
      this.setState(prev => { const next = new Set(prev.savingRows); next.delete(id); return { savingRows: next }; });
    }
  };

  handleNewRowChange = (tempId, field, value) => {
    const currentRow = this.state.newRows.find(r => r._tempId === tempId) || {};
    const updatedRow = { ...currentRow, [field]: value };
    this.setState(prev => ({
      newRows: prev.newRows.map(r => r._tempId === tempId ? { ...r, [field]: value } : r)
    }));
    if (updatedRow.concepto && updatedRow.cantidad !== '') {
      clearTimeout(this.saveTimers[tempId]);
      this.saveTimers[tempId] = setTimeout(() => this.saveNewRow(tempId), 800);
    }
  };

  saveNewRow = async (tempId) => {
    const row = this.state.newRows.find(r => r._tempId === tempId);
    if (!row || !row.concepto || row.cantidad === '') return;
    const cantidad = parseFloat(row.cantidad);
    if (isNaN(cantidad)) return;

    let rowFecha = row.fecha;
    if (this.isBudgetAccount() && !rowFecha) {
      const { selectedYear, selectedMonth } = this.state;
      const year = Number(selectedYear) || new Date().getFullYear();
      const month = selectedMonth?.value && selectedMonth.value !== '00'
        ? Number(selectedMonth.value)
        : new Date().getMonth() + 1;
      rowFecha = new Date(year, month - 1, 1, 12, 0, 0, 0);
    }

    const { fecha, fechaImputacion } = this.ensureDatePayload({
      fecha: rowFecha,
      fechaImputacion: null,
    });

    const accountForNewRow = this.state.detailMode === "grupo"
      ? Number(row.idCuentaOrigen || this.state.selectedGroupAccountId || this.state.groupAccounts?.[0]?.IDCuenta)
      : this.state.selectedAccount;

    if (!accountForNewRow) return;

    const payload = {
      fecha,
      fechaImputacion,
      concepto: row.concepto,
      detalle: row.detalle || '',
      cantidad,
      IDCategoriaFK: row.IDCategoriaFK ? { IDCategoria: parseInt(row.IDCategoriaFK) } : null,
      cuentas: [{ participacion: 100, IDCuentaFK: { IDCuenta: accountForNewRow } }],
      usuarios: [{ participacion: 100, IDUsuarioFK: { IDUsuario: this.userData.IDUsuario } }],
    };

    if (this.isBudgetAccount()) {
      payload.estadoPresupuesto = 'PLANIFICADO';
    }

    this.setState(prev => {
      const next = new Set(prev.savingRows); next.add(tempId); return { savingRows: next };
    });

    try {
      const res = await doFetch('CCON', 'insertTransactions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify([payload]),
      }).then(r => r.json());

      if (res.STATE === 'SUCCESS') {
        this.setState(prev => {
          const next = new Set(prev.savingRows); next.delete(tempId);
          return {
            savingRows: next,
            newRows: prev.newRows.map(r =>
              r._tempId === tempId
                ? {
                    _tempId: tempId,
                    fecha: '',
                    concepto: '',
                    detalle: '',
                    cantidad: '',
                    IDCategoriaFK: null,
                    IDCategoriaSearch: '',
                    idCuentaOrigen: this.state.detailMode === "grupo"
                      ? (this.state.selectedGroupAccountId !== "all" ? this.state.selectedGroupAccountId : "")
                      : '',
                  }
                : r
            ),
          };
        });
        this.getTransactions();
      } else {
        this.setState(prev => { const next = new Set(prev.savingRows); next.delete(tempId); return { savingRows: next }; });
      }
    } catch (e) {
      this.setState(prev => { const next = new Set(prev.savingRows); next.delete(tempId); return { savingRows: next }; });
    }
  };

  deleteRowInline = async (id) => {
    await doFetch('CCON', `deleteTransactions?IDTransaccion=${id}`, { method: 'DELETE' }).catch(console.error);
    this.getTransactions();
  };

  isBudgetAccount() {
    const currentAccount = this.state.allUserAccounts.find(
      (acc) => Number(acc.IDCuenta) === Number(this.state.selectedAccount)
    );
    return currentAccount?.tipo === 'BUDGET';
  }

  async cancelarPresupuesto(id) {
    this.props.onLoading(true);
    try {
      const res = await doFetch('CCON', 'cancelarPresupuesto', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ idTransaccionPresupuesto: id }),
      }).then(r => r.json());
      if (res.STATE === 'SUCCESS') {
        this.getTransactions();
      }
    } catch (e) {
      console.error('Error cancelando presupuesto:', e);
    } finally {
      this.props.onLoading(false);
    }
  }

  async replanificarPresupuesto(id) {
    this.props.onLoading(true);
    try {
      const res = await doFetch('CCON', 'replanificarPresupuesto', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ idTransaccionPresupuesto: id }),
      }).then(r => r.json());
      if (res.STATE === 'SUCCESS') {
        this.getTransactions();
      }
    } catch (e) {
      console.error('Error replanificando presupuesto:', e);
    } finally {
      this.props.onLoading(false);
    }
  }

  toggleColumn = (col) => {
    this.setState((prev) => ({
      visibleColumns: { ...prev.visibleColumns, [col]: !prev.visibleColumns[col] },
    }));
  };

  render() {
    const {
      filteredTransacciones,
      selectedBatch,
      currentPage,
      pageSize,
      batchCategoriaId,
      batchFecha,
      batchFechaContable,
      editingCells,
      savingRows,
      savedRows,
      showResumenCard,
      showIncomeCard,
      showExpenseCard,
      showColPicker,
      visibleColumns,
    } = this.state;
    const pageSizeInt = Number(pageSize) || 50;
    const totalPages = Math.max(1, Math.ceil(filteredTransacciones.length / pageSizeInt));
    const pageRows = filteredTransacciones.slice((currentPage - 1) * pageSizeInt, currentPage * pageSizeInt);
    const selectableOnPage = pageRows.filter((t) => !t.esVirtual).map((t) => t.IDTransaccion);
    const allPageSelected = selectableOnPage.length > 0 && selectableOnPage.every((id) => selectedBatch.has(id));
    const conceptosSugeridos = [...new Set(this.state.transacciones.map((t) => t.concepto).filter(Boolean))].sort();
    const resumenCategorias = this.getResumenPorCategorias(filteredTransacciones);
    const incomeDonutModel = this.buildIncomeDonutModel(filteredTransacciones);
    const expenseDonutModel = this.buildExpenseDonutModel(filteredTransacciones);
    const isGrupo = this.state.detailMode === "grupo";
    const isBudget = !isGrupo && this.isBudgetAccount();
    const groupName = this.state.groupData?.nombre || "Grupo";
    const groupAccounts = this.state.groupAccounts || [];
    const currentAccount = this.state.allUserAccounts.find(
      (acc) => Number(acc.IDCuenta) === Number(this.state.selectedAccount)
    );
    const accountName = currentAccount?.nombre || `Cuenta ${this.state.selectedAccount || ""}`;
    const accountTipo = currentAccount?.tipo || 'PERSONAL';
    const accountTypeInfo = {
      PERSONAL:        { label: 'Cuenta personal',     color: 'primary', icon: 'user' },
      SHARED_EXPENSE:  { label: 'Gastos compartidos',  color: 'info',    icon: 'users' },
      BUDGET:          { label: 'Presupuesto',          color: 'warning', icon: 'wallet' },
    }[accountTipo] || { label: 'Cuenta',              color: 'secondary', icon: 'university' };

    const budgetPlanificado = isBudget
      ? filteredTransacciones.filter((t) => t.estadoPresupuesto === 'PLANIFICADO').reduce((acc, t) => acc + Math.abs(Number(t.cantidad) || 0), 0)
      : 0;
    const budgetConfirmado = isBudget
      ? filteredTransacciones.filter((t) => t.estadoPresupuesto === 'CONFIRMADO').reduce((acc, t) => acc + Math.abs(Number(t.cantidad) || 0), 0)
      : 0;
    const budgetCancelado = isBudget
      ? filteredTransacciones.filter((t) => t.estadoPresupuesto === 'CANCELADO').reduce((acc, t) => acc + Math.abs(Number(t.cantidad) || 0), 0)
      : 0;
    const budgetTotal = budgetPlanificado + budgetConfirmado;
    const budgetProgressPct = budgetTotal > 0 ? Math.round((budgetConfirmado / budgetTotal) * 100) : 0;
    return (
      <MDBContainer fluid className="detalle-cuenta">
        {this.state.showConfirmarPresupuestoModal && this.state.selectedBudgetTransaction && (
          <ConfirmarPresupuestoModal
            show={this.state.showConfirmarPresupuestoModal}
            transaccion={this.state.selectedBudgetTransaction}
            cuentasPersonales={this.state.allUserAccounts.filter((c) => (c.tipo || 'PERSONAL') !== 'BUDGET')}
            onClose={() => this.setState({ showConfirmarPresupuestoModal: false, selectedBudgetTransaction: null })}
            onConfirmado={() => {
              this.setState({ showConfirmarPresupuestoModal: false, selectedBudgetTransaction: null });
              this.getTransactions();
            }}
            onLoading={(v) => this.props.onLoading(v)}
          />
        )}
        {this.state.showBatchDeleteAlert && (
          <PopConfirm
            show={true}
            title="Eliminar transacciones seleccionadas"
            detail={`¿Eliminar ${selectedBatch.size} transacción(es) seleccionada(s)?`}
            onConfirm={() => this.handleBatchDelete()}
            onCancel={() => this.setState({ showBatchDeleteAlert: false })}
          />
        )}
        {(this.state.showTransactionEditModal || this.state.showTransactionNewModal) && (
          <TransactionModal
            show={this.state.showTransactionEditModal || this.state.showTransactionNewModal}
            mode={this.state.showTransactionEditModal ? "edit" : "new"}
            data={this.state.showTransactionEditModal ? this.state.selectedTransactionEdit : null}
            onCloseModal={() => this.handleCloseModal()}
            onLoading={(event) => this.props.onLoading(event)}
            selectedAccount={
              this.state.detailMode === "grupo"
                ? (this.state.showTransactionEditModal
                    ? Number(this.state.selectedTransactionEdit?.idCuentaOrigen || this.state.groupAccounts?.[0]?.IDCuenta)
                    : Number(this.state.selectedGroupAccountId !== "all"
                        ? this.state.selectedGroupAccountId
                        : this.state.groupAccounts?.[0]?.IDCuenta))
                : this.state.selectedAccount
            }
            accountOptions={
              this.state.detailMode === "grupo"
                ? this.state.groupAccounts.map((c) => ({ id: Number(c.IDCuenta), nombre: c.nombre }))
                : []
            }
            conceptosSugeridos={conceptosSugeridos}
            allUserAccounts={this.state.allUserAccounts}
          />
        )}
        {this.state.showTransactionDeleteAlert ? (
          <PopConfirm
            show={this.state.showTransactionDeleteAlert}
            title="Confirmar borrar transacción"
            detail="¿Está seguro de que desea borrar la transacción?"
            onConfirm={() => this.handlerConfirmDeleteTransaction()}
            onCancel={() => this.handlerCancelDeleteTransaction()}
          />
        ) : (
          <></>
        )}
        {this.state.showImportModal && (
          <ImportTransactionsModal
            show={this.state.showImportModal}
            onClose={() => this.setState({ showImportModal: false })}
            onLoading={(event) => this.props.onLoading(event)}
            onConfirmImport={(rows) => this.processImportedRows(rows)}
          />
        )}

        <div className="detalle-entity-header mb-2 mt-2">
          <div className="d-flex align-items-center gap-3 flex-wrap">
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => this.props.onNavigate("/ccon/miscuentas")}
            >
              <MDBIcon icon="arrow-left" className="me-1" /> Mis Cuentas
            </button>
            {isGrupo ? (
              <div className="d-flex align-items-center gap-2">
                <MDBBadge color="secondary" pill style={{ fontSize: "0.75rem" }}>
                  <MDBIcon icon="layer-group" className="me-1" />Grupo
                </MDBBadge>
                <h6 className="mb-0">
                  <strong>{groupName}</strong>
                  <MDBBadge color="light" pill className="ms-2" style={{ fontSize: "0.7rem", color: '#555' }}>
                    {groupAccounts.length} cuenta{groupAccounts.length !== 1 ? "s" : ""}
                  </MDBBadge>
                </h6>
              </div>
            ) : (
              <div className="d-flex align-items-center gap-2">
                <MDBBadge color={accountTypeInfo.color} pill style={{ fontSize: "0.75rem" }}>
                  <MDBIcon icon={accountTypeInfo.icon} className="me-1" />{accountTypeInfo.label}
                </MDBBadge>
                <h6 className="mb-0">
                  <strong>{accountName}</strong>
                </h6>
              </div>
            )}
            {isGrupo ? (
              <button
                className="btn btn-sm btn-outline-primary ms-auto"
                onClick={() => this.setState({ showGrupoEditModal: true })}
              >
                <MDBIcon icon="edit" className="me-1" /> Editar grupo
              </button>
            ) : (
              <button
                className="btn btn-sm btn-outline-primary ms-auto"
                onClick={() => this.setState({ showAccountEditModal: true, selectedAccountEdit: currentAccount || { IDCuenta: this.state.selectedAccount } })}
              >
                <MDBIcon icon="edit" className="me-1" /> Editar cuenta
              </button>
            )}
          </div>
        </div>

        {/* ── Toolbar principal compacta (2 filas) ── */}
        <div className="toolbar compact-toolbar">
          <div className="toolbar-row toolbar-row-actions">
            <MDBDropdown>
              <MDBDropdownToggle size="sm" color="success" outline>
                <MDBIcon icon="file-export" className="me-1" />
                Exportar
              </MDBDropdownToggle>
              <MDBDropdownMenu>
                <MDBDropdownItem link onClick={this.exportAsCSV}>
                  CSV
                </MDBDropdownItem>
                <MDBDropdownItem link onClick={this.exportAsJSON}>
                  JSON
                </MDBDropdownItem>
                <MDBDropdownItem link onClick={this.exportAsExcel}>
                  Excel (.xlsx)
                </MDBDropdownItem>
                <MDBDropdownItem link onClick={this.exportToGoogleSheet}>
                  Google Sheets (CSV)
                </MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown>

            <MDBBtn size="sm" color="primary" outline onClick={() => this.setState({ showImportModal: true })}>
              <MDBIcon icon="file-import" className="me-1" />
              Importar
            </MDBBtn>

            <MDBBtn
              size="sm"
              color={this.state.modoVista === "contable" ? "info" : "secondary"}
              outline={this.state.modoVista !== "contable"}
              onClick={() =>
                this.setState(
                  (s) => ({
                    modoVista: s.modoVista === "bancaria" ? "contable" : "bancaria",
                  }),
                  this.filterTransactions
                )
              }
              title="Alterna entre fecha bancaria y fecha de imputación contable"
            >
              <MDBIcon icon="exchange-alt" className="me-1" />
              {this.state.modoVista === "contable" ? "Vista contable" : "Vista bancaria"}
            </MDBBtn>

            <MDBBtn
              size="sm"
              color={this.state.showAccountingInfo ? "info" : "secondary"}
              outline={!this.state.showAccountingInfo}
              onClick={() => this.setState((s) => ({ showAccountingInfo: !s.showAccountingInfo }))}
              title="Mostrar u ocultar indicadores de fecha contable en la tabla"
            >
              <MDBIcon icon="calendar-alt" className="me-1" />
              Fecha contable
            </MDBBtn>

            <MDBBtn size="sm" color="secondary" onClick={this.toggleFilterMode}>
              {this.state.showAdvancedFilters ? "Filtro sencillo" : "Filtro avanzado"}
            </MDBBtn>

            <MDBBtn size="sm" color="primary" onClick={() => this.setNewTransaction()}>
              <MDBIcon icon="plus" className="me-1" />
              Nueva transacción
            </MDBBtn>

            <MDBBtn
              size="sm"
              color={this.state.showSidePanel ? "secondary" : "light"}
              onClick={() => this.setState((s) => ({ showSidePanel: !s.showSidePanel }))}
            >
              <MDBIcon icon={this.state.showSidePanel ? "columns" : "chart-pie"} className="me-1" />
              {this.state.showSidePanel ? "Ocultar resúmenes" : "Mostrar resúmenes"}
            </MDBBtn>

            <select
              className="form-select form-select-sm"
              style={{ width: "150px" }}
              value={this.state.prorrateoFilter}
              onChange={(e) => this.setState({ prorrateoFilter: e.target.value }, this.filterTransactions)}
              title="Filtro de prorrateo"
            >
              <option value="all">Todas</option>
              <option value="prorrateadas">Prorrateadas</option>
              <option value="no_prorrateadas">No prorrateadas</option>
            </select>
          </div>

          <div className="toolbar-row toolbar-row-filters">
            {!this.state.showAdvancedFilters ? (
              <>
                <div className="date-navigator">
                  <button
                    className="btn btn-secondary btn-sm date-nav-arrow"
                    onClick={() => this.adjustMonth(-1)}
                    title="Mes anterior"
                  >
                    <MDBIcon fas icon="angle-left" />
                  </button>

                  <div className="date-stepper">
                    <button className="step-btn" onClick={() => this.adjustYear(1)} title="Año siguiente">▲</button>
                    <select
                      className="date-select"
                      value={this.state.selectedYear}
                      onChange={(e) =>
                        this.setState(
                          { selectedYear: parseInt(e.target.value, 10) },
                          this.filterTransactions
                        )
                      }
                    >
                      {Array.from({ length: 11 }, (_, i) => this.state.selectedYear - 5 + i).map((year) => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                    <button className="step-btn" onClick={() => this.adjustYear(-1)} title="Año anterior">▼</button>
                  </div>

                  <div className="date-stepper">
                    <button className="step-btn" onClick={() => this.adjustMonth(1)} title="Mes siguiente">▲</button>
                    <select
                      className="date-select"
                      value={this.state.selectedMonth.value}
                      onChange={(e) =>
                        this.handleMonthChange(this.months.find((m) => m.value === e.target.value))
                      }
                    >
                      {this.months.map((month) => (
                        <option key={month.value} value={month.value}>{month.label}</option>
                      ))}
                    </select>
                    <button className="step-btn" onClick={() => this.adjustMonth(-1)} title="Mes anterior">▼</button>
                  </div>

                  <button
                    className="btn btn-secondary btn-sm date-nav-arrow"
                    onClick={() => this.adjustMonth(1)}
                    title="Mes siguiente"
                  >
                    <MDBIcon fas icon="angle-right" />
                  </button>
                </div>

                <div className="filter-group">
                  <MDBInput
                    label="Concepto"
                    type="text"
                    value={this.state.filtroConcepto}
                    onChange={(e) =>
                      this.setState(
                        { filtroConcepto: e.target.value },
                        this.filterTransactions
                      )
                    }
                    wrapperClass="filter-input-compact"
                  />
                  <MDBInput
                    label="Categoría"
                    type="text"
                    value={this.state.filtroCategoria}
                    onChange={(e) =>
                      this.setState(
                        { filtroCategoria: e.target.value },
                        this.filterTransactions
                      )
                    }
                    wrapperClass="filter-input-compact"
                  />

                  {isGrupo && (
                    <select
                      className="form-select form-select-sm filter-select-compact"
                      value={this.state.selectedGroupAccountId}
                      onChange={(e) => this.setState({ selectedGroupAccountId: e.target.value }, this.filterTransactions)}
                      title="Filtrar por cuenta del grupo"
                    >
                      <option value="all">Todas las cuentas</option>
                      {groupAccounts.map((c) => (
                        <option key={c.IDCuenta} value={c.IDCuenta}>{c.nombre}</option>
                      ))}
                    </select>
                  )}
                </div>
              </>
            ) : (
              <div className="advanced-filters-grid">
                <MDBInput
                  label="Fecha inicio"
                  type="date"
                  value={this.state.startDate}
                  onChange={this.handleStartDateChange}
                />
                <MDBInput
                  label="Fecha fin"
                  type="date"
                  value={this.state.endDate}
                  onChange={this.handleEndDateChange}
                />
                <MDBInput
                  label="Valor min"
                  type="text"
                  value={this.state.minValue}
                  onChange={(e) => this.valorMinimo(e)}
                />
                <MDBInput
                  label="Valor max"
                  type="text"
                  value={this.state.maxValue}
                  onChange={(e) => this.valorMaximo(e)}
                />
                <MDBInput
                  label="Concepto"
                  type="text"
                  value={this.state.filtroConcepto}
                  onChange={(e) =>
                    this.setState(
                      { filtroConcepto: e.target.value },
                      this.filterTransactions
                    )
                  }
                />
                <MDBInput
                  label="Categoría"
                  type="text"
                  value={this.state.filtroCategoria}
                  onChange={(e) =>
                    this.setState(
                      { filtroCategoria: e.target.value },
                      this.filterTransactions
                    )
                  }
                />
                {isGrupo && (
                  <select
                    className="form-select form-select-sm"
                    value={this.state.selectedGroupAccountId}
                    onChange={(e) => this.setState({ selectedGroupAccountId: e.target.value }, this.filterTransactions)}
                    title="Filtrar por cuenta del grupo"
                  >
                    <option value="all">Todas las cuentas</option>
                    {groupAccounts.map((c) => (
                      <option key={c.IDCuenta} value={c.IDCuenta}>{c.nombre}</option>
                    ))}
                  </select>
                )}
              </div>
            )}
          </div>
        </div>

        {/* ── Resumen gastos compartidos (solo para cuentas SHARED_EXPENSE) ── */}
        {this.state.detailMode === "cuenta" && this.state.selectedAccount && !isBudget && (
          <SharedExpenseSummary
            key={this.state.selectedAccount}
            idCuenta={this.state.selectedAccount}
            onLoading={(v) => this.props.onLoading(v)}
          />
        )}

        <div className="transactions-main-layout">
          {this.state.showAccountEditModal && !isGrupo && this.state.selectedAccountEdit && (
            <AccountEditModal
              showAccountEditModal={this.state.showAccountEditModal}
              data={this.state.selectedAccountEdit}
              onCloseModal={() => {
                this.setState({ showAccountEditModal: false, selectedAccountEdit: null });
                this.getUserAccounts();
                this.getTransactions();
              }}
              onLoading={(event) => this.props.onLoading(event)}
            />
          )}

          {this.state.showGrupoEditModal && isGrupo && this.state.groupData && (
            <GrupoEditModal
              show={this.state.showGrupoEditModal}
              data={this.state.groupData}
              cuentasDisponibles={this.state.allUserAccounts.filter((c) => ["PERSONAL", "SHARED_EXPENSE"].includes(c.tipo || "PERSONAL"))}
              onClose={(refresh) => {
                this.setState({ showGrupoEditModal: false });
                if (refresh) this.getTransactions();
              }}
              onLoading={(event) => this.props.onLoading(event)}
            />
          )}

          {this.state.showSidePanel && (
          <aside className="transactions-side-panel">
            {isBudget ? (
              <div className="transactions-side-card">
                <button className="side-card-toggle" onClick={() => this.toggleSideCard("showResumenCard")}>
                  <h6 className="side-card-title mb-0">Resumen de presupuesto</h6>
                  <MDBIcon fas icon={showResumenCard ? "chevron-up" : "chevron-down"} />
                </button>
                {showResumenCard && (
                  <div className="p-2">
                    <div className="d-flex flex-column gap-2 mb-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="text-muted small">Planificado</span>
                        <MDBBadge color="primary" pill>{this.formatCurrency(budgetPlanificado)}</MDBBadge>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="text-muted small">Confirmado</span>
                        <MDBBadge color="success" pill>{this.formatCurrency(budgetConfirmado)}</MDBBadge>
                      </div>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="text-muted small">Cancelado</span>
                        <MDBBadge color="secondary" pill>{this.formatCurrency(budgetCancelado)}</MDBBadge>
                      </div>
                    </div>
                    <div className="mb-1">
                      <small className="text-muted">% confirmado sobre planificado</small>
                    </div>
                    <div className="progress" style={{ height: "10px" }}>
                      <div
                        className="progress-bar bg-success"
                        role="progressbar"
                        style={{ width: `${budgetProgressPct}%` }}
                        aria-valuenow={budgetProgressPct}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      />
                    </div>
                    <div className="text-end mt-1">
                      <small className="text-muted">{budgetProgressPct}%</small>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <>
            <div className="transactions-side-card">
              <button className="side-card-toggle" onClick={() => this.toggleSideCard("showResumenCard")}>
                <h6 className="side-card-title mb-0">Resumen por categorías</h6>
                <MDBIcon fas icon={showResumenCard ? "chevron-up" : "chevron-down"} />
              </button>
              {showResumenCard && (
                <div className="table-responsive">
                  <table className="table table-sm table-striped align-middle mb-0">
                    <thead>
                      <tr>
                        <th>Categoría</th>
                        <th>Tipo</th>
                        <th className="text-end">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {resumenCategorias.slice(0, 14).map((row) => (
                        <tr key={`${row.categoria}-${row.tipo}`}>
                          <td>{row.categoria}</td>
                          <td>{row.tipo}</td>
                          <td className="text-end">{this.formatCurrency(row.tipo === "Ingreso" ? row.totalSigned : Math.abs(row.totalSigned))}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div className="transactions-side-card">
              <button className="side-card-toggle" onClick={() => this.toggleSideCard("showIncomeCard")}>
                <h6 className="side-card-title mb-0">Rosco de ingresos</h6>
                <MDBIcon fas icon={showIncomeCard ? "chevron-up" : "chevron-down"} />
              </button>
              {showIncomeCard && (
                <>
                  <div className="side-donut-wrap">
                    {incomeDonutModel.chartData.labels.length > 0 ? (
                      <Doughnut
                        data={incomeDonutModel.chartData}
                        options={{
                          responsive: true,
                          plugins: { legend: { display: false } },
                        }}
                      />
                    ) : (
                      <p className="text-muted small mb-0">No hay ingresos en el filtro seleccionado.</p>
                    )}
                  </div>
                  <div className="side-legend">
                    {incomeDonutModel.rows.map((row) => (
                      <label key={`inc-${row.label}`} className="side-legend-item">
                        <input
                          type="checkbox"
                          checked={!this.state.hiddenIncomeConcepts[row.label]}
                          onChange={() => this.toggleIncomeLegendItem(row.label)}
                        />
                        <span className="side-legend-dot" style={{ backgroundColor: this.colorFromText(row.label) }} />
                        <span className="side-legend-label">{row.label}</span>
                      </label>
                    ))}
                  </div>
                </>
              )}
            </div>

            <div className="transactions-side-card">
              <button className="side-card-toggle" onClick={() => this.toggleSideCard("showExpenseCard")}>
                <h6 className="side-card-title mb-0">Rosco de gastos</h6>
                <MDBIcon fas icon={showExpenseCard ? "chevron-up" : "chevron-down"} />
              </button>
              {showExpenseCard && (
                <>
                  <div className="side-donut-wrap">
                    {expenseDonutModel.chartData.labels.length > 0 ? (
                      <Doughnut
                        data={expenseDonutModel.chartData}
                        options={{
                          responsive: true,
                          plugins: { legend: { display: false } },
                        }}
                      />
                    ) : (
                      <p className="text-muted small mb-0">No hay gastos en el filtro seleccionado.</p>
                    )}
                  </div>
                  <div className="side-legend">
                    {expenseDonutModel.rows.map((row) => (
                      <label key={`exp-${row.label}`} className="side-legend-item">
                        <input
                          type="checkbox"
                          checked={!this.state.hiddenExpenseCategorias[row.label]}
                          onChange={() => this.toggleExpenseLegendItem(row.label)}
                        />
                        <span className="side-legend-dot" style={{ backgroundColor: this.colorFromText(row.label, 68, 47) }} />
                        <span className="side-legend-label">{row.label}</span>
                      </label>
                    ))}
                  </div>
                </>
              )}
            </div>
              </>
            )}
          </aside>
          )}

          <div className="transactions-table-zone">
            {/* ── Batch action toolbar ── */}
            {selectedBatch.size > 0 && (
              <div className="d-flex align-items-center gap-2 my-2 p-2 bg-light border rounded flex-wrap">
                <span className="text-muted me-2">{selectedBatch.size} seleccionada(s)</span>
                <MDBBtn size="sm" color="danger" onClick={() => this.setState({ showBatchDeleteAlert: true })}>
                  <MDBIcon fas icon="trash" className="me-1" />
                  Eliminar
                </MDBBtn>
                <select
                  className="form-select form-select-sm"
                  style={{ width: "auto" }}
                  value={batchCategoriaId}
                  onChange={(e) => this.setState({ batchCategoriaId: e.target.value })}
                >
                  <option value="">Cambiar categoría…</option>
                  {this.mapaCategorias.map((c) => (
                    <option key={c.IDCategoria} value={c.IDCategoria}>{c.nombre}</option>
                  ))}
                </select>
                {batchCategoriaId && (
                  <MDBBtn size="sm" color="primary" onClick={() => this.handleBatchChangeCategory()}>
                    Aplicar
                  </MDBBtn>
                )}

                <input
                  type="date"
                  className="form-control form-control-sm"
                  style={{ width: "auto" }}
                  value={batchFecha}
                  onChange={(e) => this.setState({ batchFecha: e.target.value })}
                  title="Cambiar fecha normal"
                />
                {batchFecha && (
                  <MDBBtn size="sm" color="primary" outline onClick={() => this.handleBatchChangeDates({ useFecha: true })}>
                    Aplicar fecha
                  </MDBBtn>
                )}

                <input
                  type="month"
                  className="form-control form-control-sm"
                  style={{ width: "auto" }}
                  value={batchFechaContable}
                  onChange={(e) => this.setState({ batchFechaContable: e.target.value })}
                  title="Cambiar fecha contable"
                />
                {batchFechaContable && (
                  <MDBBtn size="sm" color="info" onClick={() => this.handleBatchChangeDates({ useFechaContable: true })}>
                    Aplicar contable
                  </MDBBtn>
                )}

                <MDBBtn
                  size="sm"
                  color="info"
                  outline
                  onClick={() => this.handleBatchQuickAccountingVisibleMonth()}
                  title="Asignar mes contable visible en filtros"
                >
                  Contable = mes visible
                </MDBBtn>

                <MDBBtn size="sm" color="light" onClick={() => this.setState({ selectedBatch: new Set(), batchCategoriaId: "", batchFecha: "", batchFechaContable: "" })}>
                  Deseleccionar
                </MDBBtn>
              </div>
            )}

            {/* ── Tabla de transacciones ── */}
            <div className="transactions-table-scroll">
              <MDBTable align="middle" striped hover>
          <MDBTableHead>
            {(() => {
              const resumen = this.getTransactionSummaryTotals(filteredTransacciones);
              const ingresos = resumen.ingresos;
              const gastos = Math.abs(resumen.gastosSigned);
              const balance = resumen.balance;
              const vis = visibleColumns;
              const totalVis = [true, vis.fecha, isGrupo && vis.cuenta, vis.concepto, vis.detalle, vis.cantidad, vis.categoria, true].filter(Boolean).length;
              const chipsSpan = Math.min(3, Math.max(1, totalVis - 2));
              const countSpan = Math.max(1, totalVis - 1 - chipsSpan);
              const colOptions = [
                { key: 'fecha', label: 'Fecha' },
                { key: 'concepto', label: 'Concepto' },
                { key: 'detalle', label: 'Detalle' },
                { key: 'cantidad', label: 'Cantidad' },
                { key: 'categoria', label: 'Categoría' },
                ...(isGrupo ? [{ key: 'cuenta', label: 'Cuenta' }] : []),
              ];
              if (showColPicker) {
                return (
                  <tr className="summary-row">
                    <td colSpan={99}>
                      <div className="col-picker-inline">
                        {colOptions.map(({ key, label }) => (
                          <label key={key} className="col-picker-item">
                            <input type="checkbox" checked={vis[key]} onChange={() => this.toggleColumn(key)} />
                            {label}
                          </label>
                        ))}
                        <button className="btn btn-sm btn-outline-secondary col-picker-close ms-3" onClick={() => this.setState({ showColPicker: false })}>
                          <MDBIcon fas icon="check" />
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              }
              return (
                <tr className="summary-row">
                  <td>
                    <button className="col-picker-trigger" title="Seleccionar columnas" onClick={() => this.setState({ showColPicker: true })}>
                      <MDBIcon fas icon="columns" />
                    </button>
                  </td>
                  <td colSpan={countSpan} className="text-end text-muted">
                    {filteredTransacciones.length} transacciones
                  </td>
                  <td colSpan={chipsSpan}>
                    <div className="summary-metrics-inline">
                      <span className="summary-metric-chip summary-income">
                        <strong>Ingresos:</strong> {this.formatCurrency(ingresos)}
                      </span>
                      <span className="summary-metric-chip summary-expense">
                        <strong>Gastos:</strong> {this.formatCurrency(gastos)}
                      </span>
                      <span className={`summary-metric-chip ${balance >= 0 ? "summary-balance-positive" : "summary-balance-negative"}`}>
                        <strong>Balance:</strong> {this.formatCurrency(balance)}
                      </span>
                    </div>
                  </td>
                </tr>
              );
            })()}
            <tr>
              <th scope="col">
                <input
                  type="checkbox"
                  checked={allPageSelected}
                  onChange={() => this.toggleSelectAll()}
                  title="Seleccionar página"
                />
              </th>
              {visibleColumns.fecha && (
                <th scope="col" className="sortable" onClick={() => this.sortTransactions("fecha")}>
                  Fecha
                  <MDBIcon icon={this.state.sortColumn === "fecha" && this.state.sortOrder === "asc" ? "arrow-up" : "arrow-down"} className="ms-1" />
                </th>
              )}
              {isGrupo && visibleColumns.cuenta && <th scope="col">Cuenta</th>}
              {isBudget && <th scope="col">Estado</th>}
              {visibleColumns.concepto && <th scope="col">Concepto</th>}
              {visibleColumns.detalle && <th scope="col">Detalle</th>}
              {visibleColumns.cantidad && (
                <th scope="col" className="sortable" onClick={() => this.sortTransactions("cantidad")}>
                  Cantidad
                  <MDBIcon icon={this.state.sortColumn === "cantidad" && this.state.sortOrder === "asc" ? "arrow-up" : "arrow-down"} className="ms-1" />
                </th>
              )}
              {visibleColumns.categoria && (
                <th scope="col" className="sortable" onClick={() => this.sortTransactions("categoria")}>
                  Categoría
                  <MDBIcon icon={this.state.sortColumn === "categoria" && this.state.sortOrder === "asc" ? "arrow-up" : "arrow-down"} className="ms-1" />
                </th>
              )}
              <th scope="col">Acciones</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            <datalist id="conceptos-list-inline">
              {conceptosSugeridos.map(c => <option key={c} value={c} />)}
            </datalist>
            {pageRows.map((element) => {
              const id = element.IDTransaccion;
              const isVirtual = element.esVirtual;
              const isProrrateada =
                element.IDProrrateoFK !== null &&
                element.IDProrrateoFK !== undefined &&
                Number(element.numCuota || 0) > 0;
              const isSaving = savingRows.has(id);
              const isSaved = savedRows.has(id);
              const hasEdits = Object.keys(editingCells).some(k => k.startsWith(`${id}-`));
              const cellVal = (field, fallback) =>
                editingCells[`${id}-${field}`] !== undefined ? editingCells[`${id}-${field}`] : fallback;
              const editedCatId = editingCells[`${id}-IDCategoriaFK`];
              const activeCatId = editedCatId !== undefined ? editedCatId : (element.IDCategoriaFK?.IDCategoria ?? '');
              const activeCat = (this.mapaCategorias || []).find((c) => String(c.IDCategoria) === String(activeCatId));
              const activeCatColor = activeCat?.color || element.IDCategoriaFK?.color;
              const categoriaSearch = cellVal('IDCategoriaSearch', activeCat?.nombre || element.IDCategoriaFK?.nombre || '');
              const categoriaSugeridas = this.getCategoriaSuggestions(categoriaSearch);
              const budgetEstado = isBudget ? (element.estadoPresupuesto || 'PLANIFICADO') : null;
              const isBudgetReadOnly = isBudget && budgetEstado !== 'PLANIFICADO';
              const rowClass = [
                isVirtual ? 'virtual-transaction' : '',
                !isVirtual && activeCatColor ? 'row-has-category-color' : '',
                !isVirtual && hasEdits ? 'row-editing' : '',
                isSaving ? 'row-saving' : '',
                isSaved ? 'row-saved' : '',
                isBudget && budgetEstado === 'CANCELADO' ? 'budget-cancelado' : '',
              ].filter(Boolean).join(' ');
              const rowStyle = !isVirtual && activeCatColor
                ? { '--cat-row-bg': this.hexToRgba(activeCatColor, 0.14) }
                : undefined;
              return (
                <tr key={id} className={rowClass} style={rowStyle}>
                  <td>
                    {!isVirtual && (
                      <input
                        type="checkbox"
                        checked={selectedBatch.has(id)}
                        onChange={() => this.toggleBatchItem(id)}
                      />
                    )}
                  </td>
                  {visibleColumns.fecha && (
                  <td>
                    {isVirtual ? (
                      this.formatearFecha(element.fecha)
                    ) : (
                      <input
                        type="date"
                        className="inline-input"
                        value={cellVal('fecha', this.formatearFecha(element.fecha, 'AAAA-MM-DD'))}
                        onChange={(e) => this.handleCellChange(id, 'fecha', e.target.value)}
                        readOnly={isProrrateada || isBudgetReadOnly}
                        spellCheck="false"
                      />
                    )}
                    {this.state.showAccountingInfo && element.fechaImputacion &&
                      this.getYearMonth(element.fechaImputacion) !==
                        this.getYearMonth(element.fecha) && (
                      <div>
                        <MDBBadge color="info" pill className="ms-1" style={{ fontSize: "0.65rem" }}
                          title="Mes contable asignado">
                          📅 {this.getYearMonth(element.fechaImputacion)}
                        </MDBBadge>
                      </div>
                    )}
                    {element.IDProrrateoFK && element.numCuota && (
                      <div>
                        <MDBBadge color="secondary" pill className="ms-1" style={{ fontSize: "0.65rem" }}
                          title="Cuota de prorrateo">
                          Cuota {element.numCuota}
                        </MDBBadge>
                      </div>
                    )}
                  </td>
                  )}
                  {isGrupo && visibleColumns.cuenta && (
                    <td>
                      {element.nombreCuentaOrigen ||
                        groupAccounts.find((c) => String(c.IDCuenta) === String(element.idCuentaOrigen))?.nombre ||
                        "-"}
                    </td>
                  )}
                  {isBudget && (
                    <td>
                      <MDBBadge
                        color={budgetEstado === 'PLANIFICADO' ? 'primary' : budgetEstado === 'CONFIRMADO' ? 'success' : 'secondary'}
                        pill
                      >
                        {budgetEstado}
                      </MDBBadge>
                    </td>
                  )}
                  {visibleColumns.concepto && (
                  <td>
                    {isVirtual ? (
                      <>
                        <MDBIcon icon="link" className="me-1 text-muted" title={`De: ${element.nombreCuentaGastos}`} />
                        {element.concepto}
                        <span className="ms-2 virtual-transaction-badge">{element.nombreCuentaGastos}</span>
                      </>
                    ) : (
                      <input
                        type="text"
                        list="conceptos-list-inline"
                        className="inline-input"
                        placeholder="Concepto..."
                        value={cellVal('concepto', element.concepto)}
                        onChange={(e) => this.handleCellChange(id, 'concepto', e.target.value)}
                        readOnly={isProrrateada || isBudgetReadOnly}
                        spellCheck="false"
                      />
                    )}
                  </td>
                  )}
                  {visibleColumns.detalle && (
                  <td>
                    {isVirtual ? (
                      <span className="text-muted">{element.detalle}</span>
                    ) : (
                      <input
                        type="text"
                        className="inline-input"
                        placeholder="Detalle..."
                        value={cellVal('detalle', element.detalle ?? '')}
                        onChange={(e) => this.handleCellChange(id, 'detalle', e.target.value)}
                        readOnly={isProrrateada || isBudgetReadOnly}
                        spellCheck="false"
                      />
                    )}
                  </td>
                  )}
                  {visibleColumns.cantidad && (
                  <td>
                    {isVirtual ? (
                      <MDBBadge color={element.cantidad >= 0 ? "success" : "danger"} pill>
                        {this.formatCurrency(element.cantidad)}
                      </MDBBadge>
                    ) : (
                      <input
                        type="number"
                        step="0.01"
                        className="inline-input inline-number"
                        placeholder="0.00"
                        value={cellVal('cantidad', element.cantidad)}
                        onChange={(e) => this.handleCellChange(id, 'cantidad', e.target.value)}
                        readOnly={isProrrateada || isBudgetReadOnly}
                      />
                    )}
                  </td>
                  )}
                  {visibleColumns.categoria && (
                  <td>
                    {isVirtual ? (
                      <>
                        {element.IDCategoriaFK?.color && (
                          <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', backgroundColor: element.IDCategoriaFK.color, marginRight: 6 }} />
                        )}
                        {element.IDCategoriaFK?.nombre ?? '—'}
                      </>
                    ) : (
                      <>
                        <datalist id={`cat-list-${id}`}>
                          {categoriaSugeridas.map((c) => (
                            <option key={c.IDCategoria} value={c.nombre} />
                          ))}
                        </datalist>
                        <div className="d-flex align-items-center gap-2">
                          <span
                            className="categoria-dot"
                            style={{ backgroundColor: activeCatColor || '#9e9e9e' }}
                          />
                          <input
                            type="text"
                            className="inline-input"
                            list={`cat-list-${id}`}
                            value={categoriaSearch}
                            placeholder="Categoria..."
                            onChange={(e) => this.handleCategorySearchChange(id, e.target.value)}
                            readOnly={isProrrateada || isBudgetReadOnly}
                            spellCheck="false"
                          />
                        </div>
                      </>
                    )}
                  </td>
                  )}
                  <td>
                    {!isVirtual && (
                      <div className="inline-actions">
                        {isSaving && <MDBIcon fas icon="circle-notch" spin className="text-muted saving-icon" />}
                        {isSaved && !isSaving && <MDBIcon fas icon="check" className="text-success saved-icon" />}
                        {isBudget ? (
                          <>
                            {budgetEstado === 'PLANIFICADO' && (
                              <>
                                <button
                                  className="action-btn btn-view"
                                  title="Confirmar presupuesto"
                                  onClick={() => this.setState({ showConfirmarPresupuestoModal: true, selectedBudgetTransaction: element })}
                                  style={{ color: 'green' }}
                                >
                                  <MDBIcon fas icon="check" />
                                </button>
                                <button
                                  className="action-btn btn-delete"
                                  title="Cancelar presupuesto"
                                  onClick={() => this.cancelarPresupuesto(id)}
                                >
                                  <MDBIcon icon="times" />
                                </button>
                              </>
                            )}
                            {budgetEstado === 'CANCELADO' && (
                              <button
                                className="action-btn btn-edit"
                                title="Replanificar presupuesto"
                                onClick={() => this.replanificarPresupuesto(id)}
                              >
                                <MDBIcon fas icon="undo" />
                              </button>
                            )}
                          </>
                        ) : (
                          <>
                            <button
                              className="action-btn btn-edit"
                              title="Editar (modal)"
                              onClick={() => this.setEditTransaction(element)}
                            >
                              <MDBIcon icon="edit" />
                            </button>
                            <button
                              className="action-btn btn-delete"
                              title="Eliminar"
                              onClick={() => this.deleteRowInline(id)}
                            >
                              <MDBIcon icon="times" />
                            </button>
                          </>
                        )}
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
            {this.state.newRows.map((row) => {
              const tempId = row._tempId;
              const isSaving = savingRows.has(tempId);
              return (
                <tr key={tempId} className={`row-new${isSaving ? ' row-saving' : ''}`}>
                  <td />
                  {visibleColumns.fecha && (
                  <td>
                    {!isBudget && (
                      <input
                        type="date"
                        className="inline-input"
                        value={row.fecha}
                        onChange={(e) => this.handleNewRowChange(tempId, 'fecha', e.target.value)}
                        spellCheck="false"
                      />
                    )}
                  </td>
                  )}
                  {isGrupo && visibleColumns.cuenta && (
                    <td>
                      <select
                        className="form-select form-select-sm"
                        value={row.idCuentaOrigen || ""}
                        onChange={(e) => this.handleNewRowChange(tempId, 'idCuentaOrigen', e.target.value)}
                      >
                        <option value="">Cuenta...</option>
                        {groupAccounts.map((c) => (
                          <option key={c.IDCuenta} value={c.IDCuenta}>{c.nombre}</option>
                        ))}
                      </select>
                    </td>
                  )}
                  {isBudget && (
                    <td>
                      <MDBBadge color="primary" pill>PLANIFICADO</MDBBadge>
                    </td>
                  )}
                  {visibleColumns.concepto && (
                  <td>
                    <input
                      type="text"
                      list="conceptos-list-inline"
                      className="inline-input"
                      value={row.concepto}
                      placeholder="Concepto..."
                      onChange={(e) => this.handleNewRowChange(tempId, 'concepto', e.target.value)}
                      spellCheck="false"
                    />
                  </td>
                  )}
                  {visibleColumns.detalle && (
                  <td>
                    <input
                      type="text"
                      className="inline-input"
                      value={row.detalle}
                      placeholder="Detalle..."
                      onChange={(e) => this.handleNewRowChange(tempId, 'detalle', e.target.value)}
                      spellCheck="false"
                    />
                  </td>
                  )}
                  {visibleColumns.cantidad && (
                  <td>
                    <input
                      type="number"
                      step="0.01"
                      className="inline-input inline-number"
                      value={row.cantidad}
                      placeholder="0.00"
                      onChange={(e) => this.handleNewRowChange(tempId, 'cantidad', e.target.value)}
                    />
                  </td>
                  )}
                  {visibleColumns.categoria && (
                  <td>
                    <datalist id={`new-cat-list-${tempId}`}>
                      {this.getCategoriaSuggestions(row.IDCategoriaSearch).map((c) => (
                        <option key={c.IDCategoria} value={c.nombre} />
                      ))}
                    </datalist>
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="categoria-dot"
                        style={{
                          backgroundColor:
                            (this.mapaCategorias || []).find((c) => String(c.IDCategoria) === String(row.IDCategoriaFK))?.color || '#9e9e9e',
                        }}
                      />
                      <input
                        type="text"
                        className="inline-input"
                        list={`new-cat-list-${tempId}`}
                        value={row.IDCategoriaSearch || ''}
                        placeholder="Categoria..."
                        onChange={(e) => this.handleNewRowCategorySearch(tempId, e.target.value)}
                        spellCheck="false"
                      />
                    </div>
                  </td>
                  )}
                  <td>
                    {isSaving && <MDBIcon fas icon="circle-notch" spin className="text-muted saving-icon" />}
                  </td>
                </tr>
              );
            })}
          </MDBTableBody>
              </MDBTable>
            </div>

            {/* ── Paginación ── */}
            <div className="d-flex justify-content-center align-items-center gap-3 my-3 flex-wrap">
              <div className="d-flex align-items-center gap-2">
                <span className="text-muted small">Transacciones por página:</span>
                <select
                  className="form-select form-select-sm"
                  style={{ width: "90px" }}
                  value={pageSizeInt}
                  onChange={(e) =>
                    this.setState({ pageSize: parseInt(e.target.value, 10), currentPage: 1 })
                  }
                >
                  {[25, 50, 100, 200].map((size) => (
                    <option key={size} value={size}>{size}</option>
                  ))}
                </select>
              </div>
              {totalPages > 1 && (
                <>
                <MDBBtn size="sm" color="secondary" disabled={currentPage === 1} onClick={() => this.setState({ currentPage: currentPage - 1 })}>
                  <MDBIcon fas icon="angle-left" />
                </MDBBtn>
                <span>Página {currentPage} de {totalPages}</span>
                <MDBBtn size="sm" color="secondary" disabled={currentPage === totalPages} onClick={() => this.setState({ currentPage: currentPage + 1 })}>
                  <MDBIcon fas icon="angle-right" />
                </MDBBtn>
                </>
              )}
            </div>
          </div>
        </div>
      </MDBContainer>
    );
  }
}
